// EmailModal.jsx
import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Row, Col, Alert, Badge } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";
import { getUserPracticeById } from "../../api";
import { createReminder, updateReminder } from "../../acommsapi";

// Be sure to import Quill’s CSS somewhere (e.g. in index.js or here):
import "react-quill/dist/quill.snow.css";

import ReactQuill from "react-quill";

import "./Comms.css"; // your custom overrides, if any

function EmailModal({ emailDetail, onSmsUpdate = () => {}, ...props }) {
  const [user, setUser] = useState({});
  const [practices, setPractices] = useState([]);
  const [successAlert, setSuccessAlert] = useState(false);
  const [closeAlert, setCloseAlert] = useState(false);

  // These hold the HTML content of each editor:
  const [oneDayText, setOneDayText] = useState("");
  const [sundayText, setSundayText] = useState("");

  // Which practices are checked
  const [oneDaySelected, setOneDaySelected] = useState([]);
  const [sundaySelected, setSundaySelected] = useState([]);

  // Refs to the Quill instances
  const oneDayQuillRef = useRef(null);
  const sundayQuillRef = useRef(null);

  // Available variables you can drag or click to insert
  const availableVariables = [
    { label: "First Name", value: "${appointment.patientFirstName}" },
    { label: "Last Name", value: "${appointment.patientLastName}" },
    { label: "Date", value: "${appointment.date}" },
    { label: "Time", value: "${appointment.time}" },
    { label: "Practitioner", value: "${appointment.resourceName}" },
    { label: "Practice", value: "${appointment.practiceName}" },
    { label: "Location", value: "${appointment.location.name}" },
    { label: "Location Name",     value: "${appointment.location.name}" },
  { label: "Address 1",         value: "${appointment.location.address1}" },
  { label: "Address 2",         value: "${appointment.location.address2}" },
  { label: "City",              value: "${appointment.location.city}" },
  { label: "Province/State",    value: "${appointment.location.province}" },
  { label: "Postal Code",       value: "${appointment.location.postalCode}" },
  ];

  // 1) Fetch user + practices once on mount
  useEffect(() => {
    const token = sessionStorage.getItem("user");
    if (!token) return;
    const decoded = jwtDecode(token);
    setUser(decoded);
    getUserPracticeById(decoded._id).then((userPractices) => {
      setPractices(userPractices);
    });
  }, []);

  // 2) When editing an existing reminder, populate state
  useEffect(() => {
    if (emailDetail) {
      setOneDaySelected(
        Array.isArray(emailDetail["1DayPracs"]) ? emailDetail["1DayPracs"] : []
      );
      setSundaySelected(
        Array.isArray(emailDetail.sundayPracs) ? emailDetail.sundayPracs : []
      );
      setOneDayText(emailDetail["1DayText"] || "");
      setSundayText(emailDetail.sundayText || "");
    } else {
      setOneDaySelected([]);
      setSundaySelected([]);
      setOneDayText("");
      setSundayText("");
    }
  }, [emailDetail]);

  // 3) Checkbox toggles (unchanged)
  const toggleOneDay = (num) => {
    setOneDaySelected((prev) =>
      prev.includes(num) ? prev.filter((p) => p !== num) : [...prev, num]
    );
  };
  const toggleSunday = (num) => {
    setSundaySelected((prev) =>
      prev.includes(num) ? prev.filter((p) => p !== num) : [...prev, num]
    );
  };

  // 4) Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      reminderType: "Email",
      "1DayEmailPracs": oneDaySelected,
      sundayEmailPracs: sundaySelected,
      "1DayEmailText": oneDayText,
      sundayEmailText: sundayText,
    };
    console.log("Submitting Email reminder:", payload);
    try {
      if (emailDetail && emailDetail._id) {
        await updateReminder(emailDetail._id, payload);
      } else {
        await createReminder(payload);
      }
      setSuccessAlert(true);
      setTimeout(() => {
        setSuccessAlert(false);
        props.onHide();
        onSmsUpdate();
      }, 1000);
    } catch (error) {
      console.error("Error saving Email reminder:", error);
    }
  };

  // 5) Confirm‐close logic
  const handleClose = () => setCloseAlert(true);
  const handleCancelNo = () => setCloseAlert(false);
  const handleCancelYes = () => {
    setCloseAlert(false);
    if (emailDetail) {
      setOneDaySelected(emailDetail["1DayPracs"] || []);
      setSundaySelected(emailDetail.sundayPracs || []);
      setOneDayText(emailDetail["1DayText"] || "");
      setSundayText(emailDetail.sundayText || "");
    } else {
      setOneDaySelected([]);
      setSundaySelected([]);
      setOneDayText("");
      setSundayText("");
    }
    props.onHide();
  };

  // Split practiceNumbers into two columns
  const splitInTwoCols = (arr) => {
    const half = Math.ceil(arr.length / 2);
    return [arr.slice(0, half), arr.slice(half)];
  };
  const practiceNums = practices.map((p) => p.practiceNumber);
  const [oneDayCol1, oneDayCol2] = splitInTwoCols(practiceNums);
  const [sundayCol1, sundayCol2] = splitInTwoCols(practiceNums);

  // 6) Quill toolbar and formats
  const quillModules = {
    toolbar: [
      ["bold", "italic", "underline"], // toggled buttons
      [{ align: [] }], // text align
      [{ list: "ordered" }, { list: "bullet" }], // lists
    ],
  };
  const quillFormats = [
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "align",
  ];

  // 7) Drag‐and‐drop into Quill: insert the variable text at cursor
  const handleDropIntoQuill = (e, quillRef, setHtml) => {
    e.preventDefault();
    e.stopPropagation();
    const varText = e.dataTransfer.getData("text/plain");
    if (!varText) return;
    const quill = quillRef.current.getEditor();
    // If the user has a selection, insert there; otherwise append to end
    const range = quill.getSelection();
    const index = range ? range.index : quill.getLength();
    // Insert the variable placeholder as plain text.
    // (You could wrap it in a <span class="variable">…</span> if you register a custom blot;
    // but Quill will automatically escape it as text, so for simplicity we insert plain.)
    quill.insertText(index, varText, "user");
    quill.setSelection(index + varText.length, 0);
    // Update our state (HTML) on next tick
    setTimeout(() => {
      setHtml(quill.root.innerHTML);
    }, 0);
  };

  const handleDragOverQuill = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
  };

  // 8) If the user clicks a pill, insert at cursor as well
  const handleVariableClick = (variable, quillRef, setHtml) => {
    const quill = quillRef.current.getEditor();
    quill.focus();
    const range = quill.getSelection();
    const index = range ? range.index : quill.getLength();
    quill.insertText(index, variable.value, "user");
    quill.setSelection(index + variable.value.length, 0);
    setTimeout(() => {
      setHtml(quill.root.innerHTML);
    }, 0);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="email-modal-title"
      centered
      onHide={handleClose}
      style={{ maxWidth: "90vw" }}
    >
      <Modal.Header closeButton={!closeAlert && !successAlert}>
        <Modal.Title id="email-modal-title" className="text-primary">
          {emailDetail ? "Edit Email Reminder" : "Add Email Reminder"}
        </Modal.Title>
      </Modal.Header>

      {closeAlert && (
        <Alert
          variant="info"
          className="w-100 d-flex align-items-center justify-content-between fs-6 fw-normal"
        >
          <span>
            Are you sure you want to close? Changes will not be saved.
          </span>
          <div className="ms-auto d-flex">
            <Button
              variant="outline-primary"
              className="me-1"
              onClick={handleCancelYes}
            >
              Yes
            </Button>
            <Button variant="outline-secondary" onClick={handleCancelNo}>
              No
            </Button>
          </div>
        </Alert>
      )}

      {successAlert && (
        <Alert
          variant="success"
          className="w-100 d-flex align-items-center justify-content-between fs-6 fw-normal"
        >
          <span>Email reminder saved successfully!</span>
        </Alert>
      )}

      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Form>
          <Row>
            {/* ─────────── “1 Day Before” Editor ─────────── */}
            <Col lg={6} className="pe-lg-3">
              <div className="p-3 h-100">
                <h5 className="text-primary mb-3 border-bottom pb-2">
                  1 Day Before Appointment
                </h5>

                {/* Practice Selection */}
                <div className="mb-3">
                  <h6 className="mb-2">Select Practices:</h6>
                  <Row>
                    <Col xs={6}>
                      {oneDayCol1.map((num) => (
                        <Form.Check
                          key={num}
                          type="checkbox"
                          label={
                            practices.find((p) => p.practiceNumber === num)
                              ?.practiceName || num
                          }
                          checked={oneDaySelected.includes(num)}
                          onChange={() => toggleOneDay(num)}
                          className="mb-1"
                        />
                      ))}
                    </Col>
                    <Col xs={6}>
                      {oneDayCol2.map((num) => (
                        <Form.Check
                          key={num}
                          type="checkbox"
                          label={
                            practices.find((p) => p.practiceNumber === num)
                              ?.practiceName || num
                          }
                          checked={oneDaySelected.includes(num)}
                          onChange={() => toggleOneDay(num)}
                          className="mb-1"
                        />
                      ))}
                    </Col>
                  </Row>
                </div>

                {/* Variables */}
                <VariablePills
                  editorRef={oneDayQuillRef}
                  setHtml={setOneDayText}
                  availableVariables={availableVariables}
                  onDragStart={(e, variable) => {
                    e.dataTransfer.setData("text/plain", variable.value);
                    e.dataTransfer.effectAllowed = "copy";
                  }}
                  onClick={(variable) =>
                    handleVariableClick(variable, oneDayQuillRef, setOneDayText)
                  }
                />

                {/* ReactQuill Editor */}
                <Form.Group>
                  <Form.Label>
                    <strong>Email Message:</strong>
                  </Form.Label>
                  <div
                    onDrop={(e) =>
                      handleDropIntoQuill(e, oneDayQuillRef, setOneDayText)
                    }
                    onDragOver={handleDragOverQuill}
                    style={{ marginBottom: "0.5rem" }}
                  >
                    <ReactQuill
                      ref={oneDayQuillRef}
                      theme="snow"
                      value={oneDayText}
                      onChange={setOneDayText}
                      modules={quillModules}
                      formats={quillFormats}
                      placeholder="Enter your email message for 1 day before appointments. Drag a variable or click a pill to insert."
                      style={{
                        height: "400px",

                        borderRadius: "0.25rem",
                      }}
                    />
                  </div>
                </Form.Group>
              </div>
            </Col>

            {/* ─────────── “Sunday Weekly” Editor ─────────── */}
<Col lg={6} className="ps-lg-3 mt-3 mt-lg-0">
  <div className="p-3">
    <h5 className="text-primary mb-3 border-bottom pb-2">
      Sunday Weekly Reminder
    </h5>

    {/* Practice Selection */}
    <div className="mb-3">
      <h6 className="mb-2">Select Practices:</h6>
      <Row>
        <Col xs={6}>
          {sundayCol1.map((num) => (
            <Form.Check
              key={num}
              type="checkbox"
              label={
                practices.find((p) => p.practiceNumber === num)
                  ?.practiceName || num
              }
              checked={sundaySelected.includes(num)}
              onChange={() => toggleSunday(num)}
              className="mb-1"
            />
          ))}
        </Col>
        <Col xs={6}>
          {sundayCol2.map((num) => (
            <Form.Check
              key={num}
              type="checkbox"
              label={
                practices.find((p) => p.practiceNumber === num)
                  ?.practiceName || num
              }
              checked={sundaySelected.includes(num)}
              onChange={() => toggleSunday(num)}
              className="mb-1"
            />
          ))}
        </Col>
      </Row>
    </div>

    {/* Variables */}
    <VariablePills
      editorRef={sundayQuillRef}
      setHtml={setSundayText}
      availableVariables={availableVariables}
      onDragStart={(e, variable) => {
        e.dataTransfer.setData("text/plain", variable.value);
        e.dataTransfer.effectAllowed = "copy";
      }}
      onClick={(variable) =>
        handleVariableClick(variable, sundayQuillRef, setSundayText)
      }
    />

    {/* ReactQuill Editor */}
    <Form.Group>
      <Form.Label>
        <strong>Email Message:</strong>
      </Form.Label>
      <div
        onDrop={(e) =>
          handleDropIntoQuill(e, sundayQuillRef, setSundayText)
        }
        onDragOver={handleDragOverQuill}
        style={{ marginBottom: "0.5rem" }}
      >
        <ReactQuill
          ref={sundayQuillRef}                  // ← use sundayQuillRef here
          theme="snow"
          value={sundayText}                    // ← use sundayText here
          onChange={setSundayText}              // ← use setSundayText here
          modules={quillModules}
          formats={quillFormats}
          placeholder="Enter your email message for Sunday weekly reminders. Drag a variable or click a pill to insert."
          style={{
            height: "400px",
            borderRadius: "0.25rem",
          }}
        />
      </div>
    </Form.Group>
  </div>
</Col>

          </Row>
          <Row className="mb-3"></Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-center align-items-center w-100  ">
          <Button
            variant="primary"
            className="px-5 py-2"
            onClick={handleSubmit}
          >
            {emailDetail ? "Save Changes" : "Create Email Reminder"}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default EmailModal;

// ───── VariablePills: purely presentational + drag/click handlers ─────

function VariablePills({
  editorRef,
  setHtml,
  availableVariables,
  onDragStart,
  onClick,
}) {
  return (
    <div className="mb-3">
      <small className="text-muted d-block mb-2">
        <strong>Available Variables:</strong> Drag into the editor or click to
        insert
      </small>
      <div className="d-flex flex-wrap gap-2">
        {availableVariables.map((variable, idx) => (
          <Badge
            key={idx}
            bg="primary"
            className="user-select-none"
            style={{
              cursor: "grab",
              padding: "6px 10px",
              fontSize: "0.8rem",
            }}
            draggable
            onDragStart={(e) => onDragStart(e, variable)}
            onClick={() => onClick(variable)}
            title="Drag to editor or click to insert"
          >
            {variable.label}
          </Badge>
        ))}
      </div>
    </div>
  );
}
